// Generated types for IslandRoot
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from './scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from './scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface IslandRootReadAPI extends ScopedNodeReadAPI {
}

export interface IslandRootWriteAPI extends ScopedNodeWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const IslandRootReadAPISchemaObject = ScopedNodeReadAPISchemaObject.extend({}).passthrough();
export const IslandRootReadAPISchema: z.ZodType<IslandRootReadAPI> = IslandRootReadAPISchemaObject;

export const IslandRootWriteAPISchemaObject = ScopedNodeWriteAPISchemaObject.extend({}).passthrough();
export const IslandRootWriteAPISchema: z.ZodType<IslandRootWriteAPI> = IslandRootWriteAPISchemaObject;
